import { memo } from 'react';
import clsx from 'clsx';
// mantine
import { TextInput } from '@mantine/core';
import { PopoverButton } from '@newo/ui-kit';
// icons
import { Search, Settings } from 'lucide-react';
// components
import SearchSettingsForm from '@/pages/AKB/components/Toolbar/components/SearchInput/components/SearchSettingsForm';

type SearchInputProps = {
    className?: string;
    personaId?: string;
    searchTerm?: string;
    onChange: (searchTerm: string) => void;
};

const SearchInput = ({
    className,
    personaId,
    searchTerm = '',
    onChange
}: SearchInputProps) => {
    return (
        <div className={clsx('flex items-center gap-2', className)}>
            <TextInput
                className="flex-1"
                disabled={!personaId}
                leftSection={<Search />}
                placeholder="Fuzzy search"
                value={searchTerm}
                onChange={(event) => {
                    onChange(event.target.value);
                }}
            />
            <PopoverButton
                className="leading-none"
                title="Adjust search settings"
                trigger={<Settings />}
                width={400}
            >
                {(close) => <SearchSettingsForm onClose={close} />}
            </PopoverButton>
        </div>
    );
};

export default memo(SearchInput);
